import { useContext } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

import { FlyoutFooterContext } from './FlyoutContext';

const FlyoutFooter = ({ children }) => {
  const ref = useContext(FlyoutFooterContext);
  return ref && ref.current ? createPortal(children, ref.current) : null;
};

FlyoutFooter.propTypes = {
  children: PropTypes.node,
};

export default FlyoutFooter;
